module.exports = __webpack_public_path__ + "static/media/eve-busd.e7f225fa.svg";